const TemplateVarSwitcher = (html, vars = [], type = "preview") => {
  var code = html;
  for (let i = 0; i < vars.length; i++) {
    code = code.replaceAll(vars[i]["value"], vars[i][type]);
  }
  return code;
};

export default TemplateVarSwitcher;
